export default Object.freeze({
  /**
   * Will filter the fill rate stats by the selected month on the date strip
   */
  selectedMonth: 0,
  /**
   * Will filter the fill rate stats by the selected day on the date strip
   */
  selectedDate: 1,
})
